import React from "react";
import "../styles/termsAndConditions.css";

export default function TermsAndConditions() {
  return (
    <div className="terms">
      <div className="terms__inner">
        <div className="terms__logo">GOOD <em>vibes</em> STORE</div>
        <h1 className="terms__title">Terms &amp; Conditions</h1>
        <p className="terms__updated">Last updated: May 2025</p>

        <p className="terms__intro">
          Welcome to Good Vibes Store. By creating an account or placing an order
          you agree to the following terms. Please read them carefully.
        </p>

        <section className="terms__section">
          <h2>1. About Us</h2>
          <p>
            Good Vibes Store is an online retail store based in Malawi, selling
            apparel, lights, accessories, and lifestyle products. We operate
            through our website and accept orders nationwide.
          </p>
        </section>

        <section className="terms__section">
          <h2>2. Your Account</h2>
          <p>
            You must provide accurate information when creating an account. You are
            responsible for keeping your login credentials secure. Notify us
            immediately if you suspect unauthorised use of your account.
          </p>
          <p>
            We reserve the right to suspend or close accounts that violate these
            terms or are used for fraudulent activity.
          </p>
        </section>

        <section className="terms__section">
          <h2>3. Orders &amp; Payments</h2>
          <p>
            All prices are listed in Malawian Kwacha (MK). An order confirmation
            does not constitute acceptance — we reserve the right to cancel orders
            due to stock shortages, pricing errors, or suspected fraud.
          </p>
          <p>
            Payment is required at the time of ordering. We accept mobile money
            and other payment methods shown at checkout.
          </p>
        </section>

        <section className="terms__section">
          <h2>4. Delivery</h2>
          <p>
            We deliver within Malawi. Delivery times are estimates and may vary
            depending on your location. Good Vibes Store is not responsible for
            delays caused by third-party couriers or circumstances beyond our
            control.
          </p>
          <p>
            Delivery fees, if any, will be clearly shown at checkout before you
            complete your order.
          </p>
        </section>

        <section className="terms__section">
          <h2>5. Returns &amp; Refunds</h2>
          <p>
            If you receive a damaged or incorrect item, contact us within 48 hours
            of delivery with photos of the issue. We will arrange a replacement or
            refund at our discretion.
          </p>
          <p>
            We do not accept returns for change-of-mind purchases unless the item
            is faulty or not as described.
          </p>
        </section>

        <section className="terms__section">
          <h2>6. Referral Programme</h2>
          <p>
            Our referral programme allows customers to earn rewards when they
            refer new customers who make a purchase. Referral codes may not be
            used for spam or misleading promotions. We reserve the right to
            revoke referral earnings if abuse is detected.
          </p>
        </section>

        <section className="terms__section">
          <h2>7. Privacy</h2>
          <p>
            We collect your name, phone number, email address, and order history
            to process and fulfil your orders. Your personal information is not
            sold to third parties. We may use your contact details to send order
            updates and, occasionally, promotional messages. You can opt out at
            any time by contacting us.
          </p>
        </section>

        <section className="terms__section">
          <h2>8. Intellectual Property</h2>
          <p>
            All content on this site — including product images, logos, and text —
            belongs to Good Vibes Store or its suppliers and may not be reproduced
            without permission.
          </p>
        </section>

        <section className="terms__section">
          <h2>9. Changes to These Terms</h2>
          <p>
            We may update these terms from time to time. Continued use of our
            platform after changes are posted constitutes acceptance of the
            updated terms.
          </p>
        </section>

        <section className="terms__section">
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about these terms, please reach out to us
            via our social media channels or through the contact details provided
            on our store page.
          </p>
        </section>

        <div className="terms__back">
          <button onClick={() => window.history.back()} className="terms__back-btn">
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
}
